import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { APIConnector } from "src/api/APIConnector"

const TokenLogin = () => {
    const api = APIConnector();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loginMessage, setLoginMessage] = useState("Authenticating...");

    useEffect(() => {
        if(searchParams.get("uuid")){
            if(searchParams.get("type") && searchParams.get("type") == "Vendor") {
                api.post(`/auth/vendor-token?uuid=${encodeURIComponent(searchParams.get("uuid"))}`)
                    .then((data) => {
                        if(data != null && data.token !== undefined)
                        {					
                            localStorage.setItem('token', data.token);
                            navigate('/vendor/home');
                        }
                        else	
                            setLoginMessage("Invalid Login");                        
                    })		
                    .catch((err) => { setLoginMessage("Login Failed: " + err); });
            }
            else {
                api.post(`/auth/client-token?uuid=${encodeURIComponent(searchParams.get("uuid"))}`)
                    .then((data) => {
                        if(data && data.token)
                        {					
                            localStorage.setItem('token', data.token);
                            navigate('/client/home');
                        }
                        else	
                            setLoginMessage("Invalid Login");
                    })		
                    .catch((err) => { setLoginMessage("Login Failed: " + err); });
            }            
        }
    },[searchParams]);

    return <div style={{padding:20}}> 
        {loginMessage}
    </div>
}

export default TokenLogin